export default __webpack_public_path__ + "static/media/logo_UOL_Final.99058e0e.svg";